<template>
    <div class="charts">
        <div class="top-title" v-if="citylist && citylist.length">{{ citylist[activeCity].label }}</div>
        <div class="chart-cont" ref="linechart"></div>
		<img src="@/assets/temimg15/BINTU/bg.png" class="bg-img" alt="">
		<img src="@/assets/temimg15/BINTU/icon.png" class="bg-icon" alt="">
		<img src="@/assets/temimg15/BINTU/circle.png" class="bg-circle" alt="">
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    name: 'template.scope121',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '饼图-scope122',
			timer: null,
			defaultdata: [
				{ value1: '合格数', value2: '50', value3: '东山县' },
				{ value1: '整改数', value2: '90', value3: '东山县' },
				{ value1: '转稽查数', value2: '60', value3: '东山县' },
				{ value1: '合格数', value2: '40', value3: '杏陈镇' },
				{ value1: '整改数', value2: '20', value3: '杏陈镇' },
				{ value1: '转稽查数', value2: '60', value3: '杏陈镇' },
				{ value1: '合格数', value2: '30', value3: '樟塘镇' },
				{ value1: '整改数', value2: '70', value3: '樟塘镇' },
				{ value1: '转稽查数', value2: '60', value3: '樟塘镇' },
				{ value1: '合格数', value2: '10', value3: '康美镇' },
				{ value1: '整改数', value2: '50', value3: '康美镇' },
				{ value1: '转稽查数', value2: '60', value3: '康美镇' },
				{ value1: '合格数', value2: '20', value3: '铜陵镇' },
				{ value1: '整改数', value2: '20', value3: '铜陵镇' },
				{ value1: '转稽查数', value2: '60', value3: '铜陵镇' },
				{ value1: '合格数', value2: '30', value3: '前楼镇' },
				{ value1: '整改数', value2: '30', value3: '前楼镇' },
				{ value1: '转稽查数', value2: '60', value3: '前楼镇' },
				{ value1: '合格数', value2: '40', value3: '西埔镇' },
				{ value1: '整改数', value2: '70', value3: '西埔镇' },
				{ value1: '转稽查数', value2: '60', value3: '西埔镇' },
				{ value1: '合格数', value2: '80', value3: '陈城镇' },
				{ value1: '整改数', value2: '80', value3: '陈城镇' },
				{ value1: '转稽查数', value2: '60', value3: '陈城镇' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
                { name: '区域', key: 'value3' }
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {
			},
			activeCity: '',
			citylist: []
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.setlist()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			console.log('___cccity', this.citylist, this.activeCity)
			clearInterval(this.timer);
			this.timer = null
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.linechart);
			let colorData = [
				'#F7F8FE',
				'#61EBD0',
				'#0072F8',
				'#00ffbf',
				'#00d9ff'
			];
			let vname = this.citylist[this.activeCity].label
			let vdata = this.defaultdata.filter(item => item.value3 == vname)
			let mydata = vdata.map((item, i) => {
				let newitem = {
					name: item.value1,
					value: item.value2,
					itemStyle: { color: colorData[i] }
				}
				return newitem
			})
			var Toption = {
				tooltip: {
					trigger: 'item',
					show: true
				},
				series: [
					{
						type: 'pie',
						//选中ple的中间40-50
						center: ['47%', '53%'],
						radius: ['53%', '65%'],
						label: {
							color: '#C6D2D8',
							fontSize: 12,
							alignTo: 'labelLine',
							align: 'left',
                            rich: {
                                c: {
                                    color: '#FAE82E'
                                }
                            },
							formatter: function (params) {
								// console.log(params, "|l3|");
								let newFor = `${params.data.name}\n\n{c|${params.percent}%}`;
								return newFor
							},
						},
						labelLine: {
							length: '20px',
							length2: '50px',
							lineStyle: {
								color: '#748496',
							},
						},
						// labelLayout: function (params) {
						// 	const isLeft = params.labelRect.x < myChart.getWidth() / 2;
						// 	const points = params.labelLinePoints;
						// 	// Update the end point.
						// 	points[2][0] = isLeft
						// 		? params.labelRect.x
						// 		: params.labelRect.x + params.labelRect.width;
						// 	return {
						// 		labelLinePoints: points
						// 	};
						// },
						data: mydata

					}
				]
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
		setlist() {
			this.citylist = [...new Set(this.defaultdata.map((item) => item.value3))].map((item, i) => {
				return {
					label: item,
					key: i
				}
			})
			this.activeCity = 0
			this.$emit('setlist1', this.citylist, 0)
			this.DrawEcharts()
		},
		setActive(i) {
			this.activeCity = i
			this.DrawEcharts()
		}
	},
	created() {

	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setlist(); //需要刷新的数据
	},

}
</script>

<style scoped lang="scss">
.charts {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    position: relative;
    .top-title {
        font-family: 'pmzd';
        font-weight: 400;
        font-size: 17px;
        color: #D1E9FF;
        line-height: 17px;
        position: absolute;
        left: 6px;
        top: 16px;
        &::after {
            content: '';
            width: 100%;
            height: 1px;
            background: #0080E2;
            position: absolute;
            left: 0;
            bottom: -6px;
        }
        &::before {
            content: '';
            width: 20%;
            height: 1px;
            background: #00D5FF;
            position: absolute;
            left: 0;
            bottom: -6px;
            z-index: 1;
        }
    }
    .chart-cont {
        width: 100%;
        height: 100%;
    }
	.bg-img {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: -1;
		top: 0;
		left: 0;
	}
	.bg-icon {
		position: absolute;
		width: 36px;
		height: 40px;
		z-index: -1;
		top: calc(50% - 16px);
		left: calc(50% - 30px);
	}
	.bg-circle {
		position: absolute;
		width: 98px;
		height: 98px;
		z-index: -1;
		top: calc(50% - 43px);
		left: calc(50% - 62px);
		animation: rotate1 5s linear infinite;
	}
}
@keyframes rotate1 {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>